// import external dependencies
import 'jquery';
import 'slick-carousel';
import WooCommerceRestApi from '@woocommerce/woocommerce-rest-api';

// Init woocommerce rest api
window.WooCommerce = new WooCommerceRestApi({
  url: 'https://mago.bitterend.io',
  consumerKey: 'ck_e3cab6051a6a3be420bbd21fb831aabcef5abd7a',
  consumerSecret: 'cs_6623bd8ad25131802e0f16c6020200f7ae170dde',
  version: 'wc/v3',
  axiosConfig: {
    headers: {},
  },
});

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import archiveProductData from './routes/archiveProductData';
import woocommerceCheckout from './routes/woocommerceCheckout';
import singleProduct from './routes/singleProduct';
import templateLogin from './routes/templateLogin';
import templateRegistration from './routes/templateRegistration';
import templateAccount from './routes/templateAccount';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Shop page
  archiveProductData,
  // Checkout
  woocommerceCheckout,
  // Product detail
  singleProduct,
  // Login page
  templateLogin,
  // Registration page
  templateRegistration,
  // Account page
  templateAccount,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js